// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconVideoPause: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
            <path
                fill="currentColor"
                d="M8.33333333,0 L0,0 L0,24 L8.33333333,24 L8.33333333,0 Z M20,0 L11.6666667,0 L11.6666667,24 L20,24 L20,0 Z"
            />
        </svg>
    );
};

export default React.memo(IconVideoPause);
